export default {
  payWelfareText: 'チャージ特典',
  blackFridayDiscount: 'ブラックフライデー期間限定割引',
  shareGift: 'シェア報酬',
  vipWeeklyWelfare: 'VIP週間特典',
  exchangeCoupon: 'クーポン交換',
  firstPayOff: '初回購入で最大15%OFF',
  blackFridayEvent: 'ブラックフライデーキャンペン',
  limitedTimeOff: '期間限定10%OFF',
  claimCoupon: '今すぐ受け取る',
  blackFridayTimedCoupon: 'ブラックフライデー期間限定クーポン',
  timeLeft: 'イベント終了まで：',
  claimTimeCoupon: '期間限定10%OFFクーポンをゲット',
  points: '残りポイント：${point}',
  costPointTip: 'ポイントを消費すると任意ランクのクーポンを受け取り可能',
  maxPointTip: '1つのアカウントにつき最大で500ポイントを使用可能',
  discountOff: '10%OFF',
  highestDiscount: '最大で${discount} 値下げ',
  needPoint: '${point}ポイントが必要',
  changeCurrency: '通貨変更',
  claim: '受け取る',
  claimSucc: '受領成功',
  claimFail: '受領失敗',
  pointNotEnough: 'ポイントが足りません。',
  afterClaimPoint: '受領後の残りポイント：${point}',
  footTips1: 'オーダーごとにクーポンを1枚のみ使用可能',
  footTips2: '金券の購入にはこのクーポンを使用できません',
  footTips3: 'イベントの最終解釈権は運営チームに属します。',
  ruleTitleText: 'イベントルール',
  ruleTime: 'イベント時間：2023-11-24 0:00 ～ 2023-11- 26 23:59 （UTC）',
  bfRuleText1:
    '1．イベント期間中、初めて公式チャージ画面にログインすると400ポイントを獲得でき、クーポンを交換することができます。（クーポンの交換は最大で500ポイントを使用できます）',
  bfRuleText2:
    '2．イベント期間中、ポイントを使用するとクーポンを交換できます。消費するポイントが多いほど、クーポンの割引も多くなります。交換後に対応するポイントが消費されます。',
  bfRuleText3:
    '2．オーダーごとに1枚のクーポンのみ使用できます。金券商品の購入にはブラックフライデー期間限定クーポンを使用できません。',
  bfRuleText4:
    '4．ブラックフライデー期間限定クーポンは以下の通貨のみ対応しています。',
  ableCoinsType: 'USD,JPY,KRW,TWD,EUR,HKD,GBP,CAD,AUD,RUB,MYR,THB,PLN,IDR',
  bfRuleText5:
    '5．交換後、通貨の変更やポイントの返還などはできませんので、割引情報とポイント消費にご注意ください。',
  bfRuleText6:
    '6．ブラックフライデー期間限定クーポンの有効期間は7日です。使用期限にご注意ください。',
  bfRuleText7: '7．イベントの最終解釈権は運営チームに属します。',
  thanksTip:
    'ご参加いただきありがとうございました。詳細情報は公式コミュニティをフォローしてください。',
  exchangePoints: 'ポイント交換',
  exchangeCode: '支払い方法を選んでからクーポン番号を入力してください。',
  enterExchangeCode: '交換コードを入力',
  exchangeText: '交換',
  confirmGet: '受け取る',
  couponUsedWay:
    'クーポンは指定された通貨での支払い時にのみ使用できますので、予めご注意ください。',
  confirmText: '確認',
  exchangeSucc: '交換成功',
  aboutCoins: '金券について',
  aboutCoinsText:
    '金券を使用するとゲーム内のすべてのパックおよびサービスを購入できますが、ゲーム内の金券は購入対象外です。',
  known: '了解',
  codeText: '交換コード',
  codeInvalid: '無効な交換コードです！',
  hasExchanged: '交換しました。交換コードは1回のみ使用できます。',
  hideText: 'タップで閉じる',
  //黑五的报错码
  'bf-20001': '未登録',
  'bf-20002': 'パラメータエラー。ゲーム画面を再読み込みしてください。',
  'bf-20003': 'ポイントが足りません。',
  'bf-20004':
    '受け取れません。後でもう一度試すか、お問合せに連絡してください。',
  'bf-20005': '受領済み',
  'bf-20015': 'イベント未開放です。こうご期待~',
  'bf-20016': 'イベントが終了しました。',
  bfShareText: '期間限定10%OFFクーポンをゲット',
  rightsCenterBtn: 'プレミアムセンター',
  payBtn: 'TOP UP',
  hasEqualRewardMuglo: 'Up to 1800 Diamonds BONUS from official website top-up!',
  productInterceptPopupTitle: 'Purchase Failed',
  productInterceptPopupTip: 'This item is not available in your region.<br>Please contact customer support if you have any questions.',
  productInterceptPopupConfirm: 'OK',
  vipHeadAwardText285 : '栄光の頂き（永久）',
  rightCenterNoticeTitle: 'VIPポイントシステムの「プレミアムセンター」へのアップグレードについて',
  rightCenterNoticeContent: 'VIPポイントシステムの「プレミアムセンター」へのアップグレードについて<br />親愛なる指揮官様：<br />日頃よりご愛顧いただき、誠にありがとうございます。より充実した特典体験をご提供するため、2025年7月16日に既存のVIPポイントシステムを全面的にリニューアルし、新たに「プレミアムセンター」システムを導入いたします。今回のリニューアルでは、既存のVIP特典を統合し、さらに多くの特典を追加いたします。具体的な変更点は以下の通りです：<br />一、リニューアル内容のご説明<br />毎週のログイン特典は継続いたします<br />2025年7月16日~7月29日までの期間、全てのプレイヤーは「公式サイトのチャージページ」にログインすることで、引き続き「週間VIPクーポン」を受け取ることができます。獲得できるクーポンの数は「VIPポイントイベント」と同じです。また、全てのプレイヤーは「プレミアムセンター」で新しいバージョンのクーポンと交換できます。プレミアムセンターのクーポンには最大割引額の制限があり、新しいクーポンのルールと獲得可能数については、ページ下部の表をご参照ください。<br />ご注意：クーポンの自動発行機能は手動で開始する必要があります。開始手順は以下の通りです：プレミアムセンターのトップページ - 会員特典を確認 - クーポン自動発行 - 開始をクリック - 自動交換したいクーポンを選択 - 開始を確認<br />ポイント交換の特典を追加<br />プレミアムセンターで「ポイント交換」機能が開放されます。プレイヤーはゲームへのログインや、プレミアムセンターで指定された任務の完成などを通じてポイントを獲得し、専用クーポンやレアアイテムなどの超お得なボーナスと交換できます（具体的な交換可能数はプレミアムセンターの画面をご確認ください）。<br />VIPレベル継承<br />元のVIPレベルと累計ポイントはプレミアムセンターに完全に引き継がれ、自動的に対応するプレミアムセンターのレベルに変換されます。元のVIP特典も同時に保持され、さらに最適化・アップグレードされます。<br />二、リニューアル後のメリット<br />特典がより透明に：すべての特典ルールと交換内容が明確に表示され、一括で簡単に受け取れます。<br />より豊富な還元：新たにポイント交換イベントが追加され、高価値アイテムが定期的に更新されます。<br />抽選特典：ポイント交換に加えて、抽選イベントも導入されます。ゲーム内アイテムの報酬が獲得できます。<br />三、注意事項<br />改版の移行期間（2025年7月16日~7月29日）は、旧VIPポイントの入口が段階的に閉鎖されます（ただし、閉鎖前は通常通りクーポンが発行されます）。残りのクーポンはお早めにご使用ください。「VIPポイントキャンペーン」終了後、未使用のクーポンは無効となりますのでご注意ください。<br />プレミアムセンターが開設された後、「公式チャージセンター」の「アイコン」から「プレミアムセンター」にアクセスできます。',
  rightCenterNoticeTableTitle: 'サードパーティークーポンの変更比較',
  rightCenterNoticeTableHeader1: '交換条件-プレミアムレベル',
  rightCenterNoticeTableHeader2: '元VIPレベル',
  rightCenterNoticeTableHeader3: 'クーポン割引',
  rightCenterNoticeTableHeader4: '獲得制限',
  rightCenterNoticeTableHeader5: '減免上限',
  rightCenterNoticeTableLevel1: 'ブロンズ',
  rightCenterNoticeTableLevel2: 'シルバー',
  rightCenterNoticeTableLevel3: 'ゴールド',
  rightCenterNoticeTableLevel4: 'プラチナ',
  rightCenterNoticeTableLevel5: 'ダイヤ',
  rightCenterNoticeTableCount1: '1回/日',
  rightCenterNoticeTableCount2: '15回/月',
  rightCenterNoticeTableCount3: '10回/月',
  rightCenterNoticeTableLimit: '15USD',
  rightCenterNoticeTableTip: 'ご注意：「プレミアムセンター」のクーポン減免上限はUSDを基準としており、為替レートの変動の影響を受けます。実際の使用ページの表示を基準としてください。',
  '-': '-'
};
